import React from 'react';

const GOOGLE_AUTH_ENDPOINT = process.env.REACT_APP_GOOGLE_AUTH_ENDPOINT
const CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID
const REDIRECT_URI = process.env.REACT_APP_GOOGLE_REDIRECT_URI
class GoogleLogin extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      // ログインチェック結果.
      isGoogleAuthenticated: false,
      isLoading: true
    }
  }

  render() {
    let authorizeUrl = GOOGLE_AUTH_ENDPOINT + "?"
    authorizeUrl += "client_id=" + CLIENT_ID + "&"
    authorizeUrl += "response_type=code&"
    authorizeUrl += `redirect_uri=${REDIRECT_URI}&`
    authorizeUrl += "scope=https://www.googleapis.com/auth/admin.directory.user&"
    authorizeUrl += "approval_prompt=force&"
    authorizeUrl += "access_type=offline"
    return (
      <div>
        <div className="header">
          <h2 className="text-center">G Suite連携アプリ</h2>
        </div>
        <div className="vb-container">
          <a href={authorizeUrl} className="vb-jumpButton">GSuiteアカウントへログイン</a>
          <br />
          <br />
          続けてGSuiteアカウントでのログインが必要です
      </div>
      </div >
    )
  }
}
export default GoogleLogin;